import { Badge, Input } from "antd";
import classNames from "classnames";
import React, { ChangeEvent, FC, useCallback, useMemo } from "react";
import {
  ConfigDynamicTrackerFields,
  DynamicOutputMaterialData,
  MaterialCategoryFieldItem,
} from "shared/api";
import { useTranslation } from "react-i18next";

interface ProdTextInputProps {
  card: ConfigDynamicTrackerFields;
  cardIndex: number;
  dynamicTracker: DynamicOutputMaterialData[];
  field: MaterialCategoryFieldItem;
  inputIndex: number;
  memoizedSetFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void;
}

// eslint-disable-next-line react/display-name
const ProdTextInput: FC<ProdTextInputProps> = React.memo(
  ({
    card,
    cardIndex,
    dynamicTracker,
    field,
    inputIndex,
    memoizedSetFieldValue,
  }) => {
    const { t } = useTranslation("", { keyPrefix: "orders" });

    const value =
      dynamicTracker?.[0]?.dynamic_tracker_fields?.[card?.title]?.[field.name];

    const currentField = card?.fields?.[cardIndex];
    const fieldName = `output_materials.${inputIndex}.dynamicData.${0}.dynamic_tracker_fields.${
      card.title
    }.${field.name}`;

    const { isRequired } = useMemo(
      () => ({
        isRequired: currentField?.required,
      }),
      [currentField]
    );

    const handleChange = useCallback(
      (e: ChangeEvent<HTMLInputElement>) => {
        memoizedSetFieldValue(fieldName, e.target.value);
      },
      [inputIndex, memoizedSetFieldValue, 0, card.title, field.name]
    );

    return (
      <div className="flex flex-col gap-y-2">
        <Badge.Ribbon text="" color={isRequired ? "red" : "transparent"}>
          <Input
            type="text"
            value={value}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChange(e)
            }
            placeholder={t("enterTextValue")!}
            className={classNames("mt-1 relative", {})}
          />
        </Badge.Ribbon>
      </div>
    );
  }
);

export { ProdTextInput };
